import React from 'react';
import { observer } from 'mobx-react';
import Styled from 'styled';

import defaultStyles from './social-button-view.scss';

@Styled(defaultStyles)
@observer
class SocialButtonView extends React.Component {
    render() {
        const { styles, icon, label, count, onCountClick, href, ...rest } = this.props;

        const props = {
            ...rest,
            className: styles.button,
        };

        const classNames = [styles.socialButton];

        if (count) {
            classNames.push(styles.hasCount);
        }

        if (href) {
            Object.assign(props, {
                href,
                target: '_blank',
                rel: 'noopener',
            });

            classNames.push(styles.hasHref);
        }

        return (
            <span className={classNames.join(' ')}>
                {React.createElement(
                    href ? 'a' : 'button',
                    props,
                    <span className={styles.content}>
                        <span key='left' className={styles.left}>
                            {React.cloneElement(icon, { style: { image: styles.icon } })}
                            <span className={styles.label}>{label}</span>
                        </span>
                    </span>
                )}
                {count != null ? (
                    <button key='right' onClick={onCountClick} className={styles.right}>
                        {count}
                    </button>
                ) : null}
            </span>
        );
    }
}

export default SocialButtonView;
